import type { JSX, ReactNode } from 'react';
import { Navigate } from 'react-router';
import type { Action } from '@artosera/shared/permissions';
import { usePeut } from './usePeut.js';

/**
 * Garde de droit (ARTO-58), posé après `RequireConsoleAuth` : renvoie vers la
 * vue d'aigle, la seule page que tout rôle de la console peut lire, quand la
 * matrice refuse l'action. C'est ce qui confine l'associé. L'API refuse de son
 * côté (403) : ce garde évite seulement d'afficher un écran voué à échouer.
 */
export function RequireAction({
  action,
  children,
}: {
  action: Action;
  children: ReactNode;
}): JSX.Element {
  const peut = usePeut();
  if (!peut(action)) {
    return <Navigate to="/vue-d-aigle" replace state={{ accesRefuse: action }} />;
  }
  return <>{children}</>;
}
